<template>
  <div class="identity">
    <vis-login-header />
    <main
      class="identity__wrap ba-bottom-0 lg:ba-fixed ba-inset-x-0 ba-w-full ba-flex ba-flex-wrap ba-justify-center ba-content-start ba-z-4"
    >
      <div class="identity__wrap-container ba-relative lg:ba-overflow-y-auto ba-w-full lg:ba-mt-20">
        <div class="container md:ba-relative md:ba-z-50 md:ba-w-full md:ba-overflow-y-auto ba-py-16 lg:ba-pt-0 lg:ba-mt-32">
          <img
            v-if="false"
            src="/img/rhombus.svg"
            class="ba-hidden lg:ba-block ba-absolute ba-bottom-1/5 ba-right-10 xl:ba--right-1/12"
          />
          <img
            v-if="false"
            src="/img/stairs.svg"
            class="ba-hidden lg:ba-block ba-absolute ba-bottom-1/5 ba--left-1/6"
          />
          <slot />
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import VisLoginHeader from "./vis-login-header";

export default {
  name: "vis-login-layout",
  components: {
    VisLoginHeader
  }
};
</script>
